// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'workerize-loader!./worker' or ... Remove this comment to see the full error message
import Worker from 'workerize-loader!./worker' // eslint-disable-line import/no-webpack-loader-syntax

export default Worker
